module.exports = __webpack_public_path__ + "img/hiw.a80791f6.png";